<template>
  <li class="nav-list" :style="{ '--primary-bg': $root.color_schema.primary }">
    <template v-if="menu.object === 'custom'">
      <a
        class="nav-link"
        :title="menu.title"
        v-if="menu.url && menu.url != ''"
        :href="menu.url"
      >
        <object
          :class="{
            'grayscale-invert-light': !getContrastYIQ(
              $root.color_schema.primary
            ),
            'grayscale-invert-dark': getContrastYIQ($root.color_schema.primary),
          }"
          v-if="menu.menu_item_icon"
          :data="menu.menu_item_icon"
          type="image/svg+xml"
        />
        <span
          :class="{
            'text-nav': getContrastYIQ($root.color_schema.primary),
            'text-white': !getContrastYIQ($root.color_schema.primary),
          }"
          >{{ menu.title }}</span
        >
      </a>
      <template v-else>
        <object
          :class="{
            'nav-link': true,
            'grayscale-invert-light': !getContrastYIQ(
              $root.color_schema.primary
            ),
            'grayscale-invert-dark': getContrastYIQ($root.color_schema.primary),
          }"
          v-if="menu.menu_item_icon"
          :data="menu.menu_item_icon"
          type="image/svg+xml"
        />
        <span
          :class="{
            'span-text nav-link': true,
            'text-nav': getContrastYIQ($root.color_schema.primary),
            'text-white': !getContrastYIQ($root.color_schema.primary),
          }"
          >{{ menu.title }}</span
        >
      </template>
    </template>
    <template v-else>
      <template v-if="$root.enable_piwik_reload">
        <a
          :title="menu.title"
          :href="getRouteLink(menu.slug, menu.object, menu.base_slug)"
          class="nav-link"
        >
          <object
            :class="{
              'grayscale-invert-light': !getContrastYIQ(
                $root.color_schema.primary
              ),
              'grayscale-invert-dark': getContrastYIQ(
                $root.color_schema.primary
              ),
            }"
            v-if="menu.menu_item_icon"
            :data="menu.menu_item_icon"
            type="image/svg+xml"
          />
          <span
            :class="{
              'text-nav': getContrastYIQ($root.color_schema.primary),
              'text-white': !getContrastYIQ($root.color_schema.primary),
            }"
            >{{ menu.title }}</span
          >
        </a>
      </template>
      <template v-else>
        <router-link
          :title="menu.title"
          tag="a"
          :to="getRouteLink(menu.slug, menu.object, menu.base_slug)"
          class="nav-link"
        >
          <object
            :class="{
              'grayscale-invert-light': !getContrastYIQ(
                $root.color_schema.primary
              ),
              'grayscale-invert-dark': getContrastYIQ(
                $root.color_schema.primary
              ),
            }"
            v-if="menu.menu_item_icon"
            :data="menu.menu_item_icon"
            type="image/svg+xml"
          />
          <span
            :class="{
              'text-nav': getContrastYIQ($root.color_schema.primary),
              'text-white': !getContrastYIQ($root.color_schema.primary),
            }"
            >{{ menu.title }}</span
          >
        </router-link>
      </template>
    </template>
    <template v-if="menu.children && menu.children.length > 0">
      <ChildMenu :menus="menu.children" left="0%" top="100%" />
    </template>
  </li>
</template>

<script>
import ChildMenu from "./ChildMenu";
import { getContrastYIQ } from "@/misc/misc-function";
export default {
  props: ["menu"],
  methods: {
    getContrastYIQ,
  },
  components: {
    ChildMenu,
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.header-arrow {
  margin-left: auto;
  @media (min-width: @sizes[large]) {
    display: none;
  }
}

.nav-link {
  margin: 21px 0;
  padding: 0 5px;
  font-size: 15px;
  display: inline-flex;
  background-color: transparent;
  border: none;
  border-radius: 10px;
  opacity: 1;
  color: #fff;
  font-family: var(--default-regular);
  font-weight: 300;
  @media (min-width: @sizes[md-large]) {
    padding: 0 10px;
  }
  span {
    line-height: 18px;
  }
}
span {
  color: #fff;
}
img {
  display: inline-block;
  max-width: 100%;
  height: auto;
  vertical-align: bottom;
  margin-right: 10px;
  @media (min-width: @sizes[tablet]) {
    margin-right: 5px;
  }
  @media (min-width: @sizes[md-large]) {
    margin-right: 10px;
  }
}

//Child Menu
.child-menu {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  width: 100%;
  z-index: 1;
  right: 105%;
  left: 0 !important;
  top: 100%;
  padding: 10px 0px;
  min-width: max-content;
  height: inherit;
  box-sizing: border-box;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.2);
  margin: 0;
  background-color: @white;
  transition: 0.5s;
  li {
    background-color: @white !important;
    padding-bottom: 28px;
    a {
      color: #222222 !important;
      padding: 0 !important;
      border-bottom: none !important;
      margin: 0;
    }
    &:first-child {
      padding-top: 16px;
    }
    &:last-child {
      padding-bottom: 16px;
    }
  }
}

.nav-list {
  display: flex !important;
  background: var(--primary-bg);
  max-width: unset;
  overflow-wrap: normal;
  @media (min-width: @sizes[tablet]) {
    max-width: 135px;
    overflow-wrap: break-word;
  }
  @media (min-width: @sizes[md-large]) {
    max-width: unset;
    overflow-wrap: normal;
  }
  &:hover {
    background: rgba(255, 255, 255, 0.3);
    .child-menu {
      visibility: visible;
      opacity: 1;
    }
  }
}

.grayscale-invert {
  filter: grayscale(1) invert(1);
  -webkit-filter: grayscale(1) invert(1);
}

.grayscale-invert-dark {
  svg > path {
    fill: #222222 !important;
  }
  max-height: 17px;
  max-width: 17px;
  display: inline-block;
  height: auto;
  vertical-align: bottom;
  margin-right: 10px;
  filter: grayscale(1) invert(1);
  -webkit-filter: grayscale(1) invert(1);
  -ms-filter: grayscale(1) invert(1);
  @media (min-width: @sizes[tablet]) {
    margin-right: 5px;
  }
  @media (min-width: @sizes[md-large]) {
    margin-right: 10px;
  }
}

.grayscale-invert-light {
  svg > path {
    fill: #ffffff;
  }
  max-height: 17px;
  max-width: 17px;
  display: inline-block;
  height: auto;
  vertical-align: bottom;
  margin-right: 10px;
  @media (min-width: @sizes[tablet]) {
    margin-right: 5px;
  }
  @media (min-width: @sizes[md-large]) {
    margin-right: 10px;
  }
}

.span-text {
  line-height: 18px;
}

.sticky-header {
  .cssmenu > ul > li > a.nav-link {
    margin: 24px 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ui/NavMenu.vue